var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container px-lg-4 px-0"},[_c('header',{staticClass:"default heade-sticky"},[_c('div',{staticClass:"un-title-page go-back"},[_c('a',{staticClass:"icon",attrs:{"href":"#"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"ri-arrow-drop-left-line"})])])]),_c('div',{staticClass:"space-sticky"})])
}
var staticRenderFns = []

export { render, staticRenderFns }